// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1XSjm","approved":"Status_approved__2Rkf-","rejected":"Status_rejected__3Il7y","expired":"Status_expired__3NMfx","label":"Status_label__1ctJg"};